// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"e1030a9b","270":"f671bdef","406":"7928fc36","453":"6e8dc333","699":"03c2bc9a","873":"e184c7b8","889":"c059346f","932":"e5ef464d"}[chunkId] + ".chunk.js";
};